import { render } from "./Secondary_School_Qualifications.vue?vue&type=template&id=529f30d8&scoped=true"
import script from "./Secondary_School_Qualifications.vue?vue&type=script&lang=js"
export * from "./Secondary_School_Qualifications.vue?vue&type=script&lang=js"

import "./Secondary_School_Qualifications.vue?vue&type=style&index=0&id=529f30d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529f30d8"]])

export default __exports__